import React from "react";
import { Modal, Button } from "semantic-ui-react";
import "./index.css";

function ConfirmationModal({
  size,
  open,
  onCancel,
  cancelText,
  onConfirm,
  content,
  confirmText,
  confirmColor = "blue",
  cancelColor = "black",
}) {
  return (
    <Modal size={size} open={open} onClose={onCancel}>
      <Modal.Content>
        <p> {content} </p>
      </Modal.Content>
      <Modal.Actions>
        <Button color={cancelColor} onClick={onCancel}>
          <span className="confirmation-modal-btn-text">{cancelText}</span>
        </Button>
        <Button color={confirmColor} onClick={onConfirm}>
          <span className="confirmation-modal-btn-text">{confirmText}</span>
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

export default ConfirmationModal;



// WEBPACK FOOTER //
// ./src/components/ConfirmationModal/index.js